import FormCategory from "./FormCategory";
import Language from "./Language";

export default class Form {
    public title: string = '';
    public url: string = '';
    public attachmentUrl: string = '';
    public videoUrl: string = '';
    public category: FormCategory = new FormCategory();
    public language: Language = new Language();
}